import React from "react";
import ReactDOM from "react-dom/client";
import ContableWebApp from "./App-final";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ContableWebApp />
  </React.StrictMode>
);
